/**
 * PRJCT Paintball - Scroll Animations
 * Handles fade-in and slide-up animations on scroll
 */

class ScrollAnimations {
  constructor() {
    this.elements = document.querySelectorAll('.animate-on-scroll, .fade-in-scroll');
    this.observer = null;
    this.init();
  }

  init() {
    // Use Intersection Observer for better performance
    const options = {
      root: null,
      rootMargin: '0px 0px -100px 0px', // Trigger slightly before element enters viewport
      threshold: 0.1
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          // Optional: Stop observing after animation
          this.observer.unobserve(entry.target);
        }
      });
    }, options);

    // Observe all elements
    this.elements.forEach(element => {
      this.observer.observe(element);
    });
  }

  // Cleanup method
  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

// Initialize animations when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ScrollAnimations();
  });
} else {
  new ScrollAnimations();
}

// Reinitialize on Shopify section render (for theme editor)
document.addEventListener('shopify:section:load', () => {
  new ScrollAnimations();
});
